import type { ActivityStatus } from '@rat/shared';
import { stepperNodes } from '../lib/activityStepper';

/**
 * Linea de tiempo de la cabecera del detalle de actividad: ilumina el hito del estado actual con el mismo tono que su
 * pastilla (amarillo observado, verde aprobado...). Ver lib/activityStepper.ts para el mapeo de los 7 estados a 5 hitos.
 */
export function ActivityStepper({ status, hadObservations }: { status: ActivityStatus; hadObservations?: boolean }) {
  return (
    <ol className="stepper" aria-label="Flujo de la actividad">
      {stepperNodes(status, hadObservations).map((n, i) => (
        <li key={i} className={`step step--${n.state} step--${n.tone}`} aria-current={n.state === 'current' ? 'step' : undefined}>
          <span className="step__dot" aria-hidden>
            {n.state === 'done' ? '✓' : n.state === 'skipped' ? '–' : i + 1}
          </span>
          <span className="step__label">{n.label}</span>
          {n.state === 'skipped' && <span className="sr-only"> (omitido: sin observaciones)</span>}
          {n.state === 'done' && <span className="sr-only"> (completado)</span>}
        </li>
      ))}
    </ol>
  );
}
